export enum TabsVariant {
  UNDERLINE = 'underline',
  FILLED = 'filled',
  NORMAL = 'normal',
}

export type TabId = string | number;

export interface TabsProps {
  className?: string;
  defaultTabId: TabId;
  children?: React.ReactNode;
  variant?: TabsVariant;
  selectedTab?: TabId;
  GetActiveTabId?: (activeTab: TabId) => void;
}

export type TabProps = {
  children: React.ReactNode;
  tabId: TabId;
  className?: string;
  onTabClick?: () => void;
  isActive?: boolean;
  disabled?: boolean;
};

export type TabListProps = { children: React.ReactNode; className?: string };

export type TabPanelProps = {
  children: React.ReactNode;
  tabId: TabId;
};

export type TabsContextValue = {
  selectedTabId: TabId;
  setSelectedTabId: (tabId: TabId) => void;
  variant: TabsVariant;
};
